module.exports = __webpack_public_path__ + "static/img/memberInfo_banner.a40749bd.png";